import React, { useEffect, useState } from "react";

// Import components
import Layout from "../Layout/Layout";
import FixedTable from "../Layout/Components/Table/FixedTable";
import Loading from "../Layout/Components/Loading";
import ConfirmDialog from "../../Helpers/Dialog/ConfirmDialog";
import Menu from "../../Helpers/menu";
import { PeopleFill, PlusCircle } from "react-bootstrap-icons";

// Import the CSS file
import "./Client.css";

// Import the translation hook
import { useTranslation } from "react-i18next";
import { useClient } from "../../Hook/Client/useClient";

// Import API service
import { applyCnpjMask, applyCpfMask } from "../../Helpers/Masc";
import { useNavigate } from "react-router-dom";
import { PencilSquare, Trash } from "react-bootstrap-icons";

export default function ClientList() {
    // Hook to use the client functions
    const {
        loading,
        clients,
        fetchListClients,
        setSearch,
        showConfirmDialog,
        itemDelete,
        deleteClientConfirm,
        deleteCancel,
        deleteClient,
    } = useClient();

    // Hook to use the translation functions
    const { t } = useTranslation();

    // Hook to navigate
    const navigate = useNavigate();

    // Set the title of the page
    document.title = t("client.title-page.list");

    // Reload the data
    const [reload, setReload] = useState(0);
    useEffect(() => {
        fetchListClients();
        // eslint-disable-next-line
    }, [reload]);

    // Edit the client
    const editClient = (client) => {
        navigate(`/client/${client.id}`);
    };

    // List data from the client table
    const tableColumns = [
        { field: "id", label: "#", type: "number" },
        { field: "name", label: t("client.table.name"), type: "string" },
        {
            field: "cpf_cnpj",
            label: t("client.table.document"),
            type: "string",
            masc: (value) => {
                return value.length <= 11
                    ? applyCpfMask(value)
                    : applyCnpjMask(value);
            },
        },
        {
            field: "is_active",
            label: t("client.table.is_inactive"),
            type: "boolean",
        },
        {
            field: "create_at",
            label: t("client.table.create_at"),
            type: "date-time",
        },
        {
            field: "create_user.name",
            label: t("client.table.create_user"),
            type: "string",
        },
        {
            field: "update_at",
            label: t("client.table.update_at"),
            type: "date-time",
        },
        {
            field: "update_user.name",
            label: t("client.table.update_user"),
            type: "string",
        },
        {
            field: "actions",
            label: t("client.table.actions"),
            type: "actions",
            actions: [
                { icon: <PencilSquare />, handle: editClient },
                { icon: <Trash />, handle: deleteClientConfirm },
            ],
        },
    ];

    const menuItens = [
        {
            type: "button",
            label: t("client.menu.new"),
            icon: <PlusCircle />,
            action: () => {
                navigate("/client/create");
            },
        },
    ];

    return (
        <>
            <ConfirmDialog
                show={showConfirmDialog}
                handleClose={deleteCancel}
                handleConfirm={deleteClient}
                title={t("client.delete.dialog.title")}
                message={t("client.delete.dialog.message", { client: itemDelete?.name })}
            />

            <Layout>
                <div className="m-3">
                    <Menu
                        icon={<PeopleFill />}
                        search={(value) => {
                            setSearch(value);
                        }}
                        clean={() => setSearch("")}
                        menu={menuItens}
                        placeholderSearch="client.menu.search"
                    />
                    {loading ? (
                        <Loading />
                    ) : (
                        <FixedTable
                            table="clients"
                            columns={tableColumns}
                            data={clients}
                            reload={() => setReload(reload + 1)}
                            empty={t("client.table.empty")}
                        />
                    )}
                </div>
            </Layout>
        </>
    );
}
